
import React from 'react';

interface Props {
  name: 'home' | 'business' | 'studio' | 'ops' | 'search' | 'customers' | 'calendar'
       | 'money' | 'inbox' | 'analytics' | 'ai' | 'media' | 'visuals' | 'monitor'
       | 'database' | 'integrations' | 'settings' | 'chevron-right' | 'chevron-down'
       | 'bell' | 'plus' | 'x' | 'menu' | 'files' | 'research' | 'assets' | 'video'
       | 'kanban' | 'terminal' | 'bookmarks' | 'wiki';
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const PATHS: Record<Props['name'], React.ReactNode> = {
  home: (
    <>
      <path d="M3 10.5 12 3l9 7.5"/>
      <path d="M5.5 9.5V21h13V9.5"/>
      <path d="M10 21v-6h4v6"/>
    </>
  ),
  business: (
    <>
      <path d="M9 7V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1"/>
      <rect x="4" y="7" width="16" height="13" rx="2"/>
      <path d="M4 12h16"/>
      <path d="M10 12v1a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-1"/>
    </>
  ),
  studio: (
    <>
      <path d="M12 2l1.2 4.2L17 7.5l-3.8 1.3L12 13l-1.2-4.2L7 7.5l3.8-1.3L12 2z"/>
      <path d="M19 12l.7 2.4 2.3.8-2.3.8L19 18l-.7-2.4-2.3-.8 2.3-.8L19 12z"/>
    </>
  ),
  ops: (
    <>
      <rect x="4" y="4" width="16" height="6" rx="2"/>
      <rect x="4" y="14" width="16" height="6" rx="2"/>
      <path d="M7.5 7h.01"/>
      <path d="M7.5 17h.01"/>
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6"/>
      <path d="M20 20l-3.5-3.5"/>
    </>
  ),
  customers: (
    <>
      <path d="M16 21v-1.5a3.5 3.5 0 0 0-7 0V21"/>
      <circle cx="12.5" cy="9" r="3"/>
      <path d="M19.5 21v-1a3 3 0 0 0-2.4-2.94"/>
      <path d="M17.3 7.4A3 3 0 0 1 18 9.2"/>
    </>
  ),
  calendar: (
    <>
      <rect x="4" y="5" width="16" height="16" rx="2"/>
      <path d="M8 3v4M16 3v4M4 11h16"/>
      <path d="M8 15h.01M12 15h.01M16 15h.01"/>
    </>
  ),
  money: (
    <>
      <rect x="3.5" y="6" width="17" height="12" rx="2"/>
      <path d="M3.5 10h17"/>
      <path d="M7 15h6M7 13h3"/>
    </>
  ),
  inbox: (
    <>
      <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/>
      <path d="M22 8l-10 7L2 8"/>
    </>
  ),
  analytics: (
    <>
      <path d="M3 20h18"/>
      <path d="M7 20V12"/>
      <path d="M11 20V8"/>
      <path d="M15 20v-5"/>
      <path d="M19 20V4"/>
    </>
  ),
  ai: (
    <>
      <path d="M12 2l1.2 4.2L17 7.5l-3.8 1.3L12 13l-1.2-4.2L7 7.5l3.8-1.3L12 2z"/>
      <path d="M19 12l.7 2.4 2.3.8-2.3.8L19 18l-.7-2.4-2.3-.8 2.3-.8L19 12z"/>
      <path d="M5 17l.5 1.7 1.7.6-1.7.6L5 21.5l-.5-1.6-1.7-.6 1.7-.6L5 17z"/>
    </>
  ),
  research: (
    <>
      <circle cx="11" cy="11" r="6"/>
      <path d="M20 20l-3.5-3.5"/>
      <path d="M11 8v6M8 11h6"/>
    </>
  ),
  media: (
    <>
      <rect x="3.5" y="6" width="17" height="12" rx="2"/>
      <path d="M7 6v12M17 6v12M3.5 10h17"/>
    </>
  ),
  visuals: (
    <>
      <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5z"/>
      <path d="M9 12l2 2 4-4"/>
    </>
  ),
  assets: (
    <>
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
      <path d="M13 2v7h7"/>
    </>
  ),
  monitor: (
    <>
      <rect x="4" y="4" width="16" height="6" rx="2"/>
      <rect x="4" y="14" width="16" height="6" rx="2"/>
      <path d="M7.5 7h.01M7.5 17h.01"/>
    </>
  ),
  files: (
    <>
      <path d="M4 20V6a2 2 0 0 1 2-2h6l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/>
      <path d="M12 4v5h5"/>
    </>
  ),
  database: (
    <>
      <ellipse cx="12" cy="6" rx="8" ry="3"/>
      <path d="M4 6v4c0 1.66 3.58 3 8 3s8-1.34 8-3V6"/>
      <path d="M4 10v4c0 1.66 3.58 3 8 3s8-1.34 8-3v-4"/>
      <path d="M4 14v4c0 1.66 3.58 3 8 3s8-1.34 8-3v-4"/>
    </>
  ),
  integrations: (
    <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </>
  ),
  'chevron-right': <path d="M9 18l6-6-6-6"/>,
  'chevron-down': <path d="M6 9l6 6 6-6"/>,
  bell: (
    <>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </>
  ),
  plus: <path d="M12 5v14M5 12h14"/>,
  x: <path d="M18 6 6 18M6 6l12 12"/>,
  menu: (
    <>
      <path d="M3 12h18M3 6h18M3 18h18"/>
    </>
  ),
  video: (
    <>
      <polygon points="23 7 16 12 23 17 23 7"/>
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
    </>
  ),
  kanban: (
    <>
      <rect x="3" y="3" width="5" height="18" rx="1"/>
      <rect x="10" y="3" width="5" height="12" rx="1"/>
      <rect x="17" y="3" width="5" height="8" rx="1"/>
    </>
  ),
  terminal: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2"/>
      <path d="M7 9l3 3-3 3"/>
      <path d="M13 15h4"/>
    </>
  ),
  bookmarks: (
    <>
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
    </>
  ),
  wiki: (
    <>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
      <path d="M8 7h8M8 11h8M8 15h5"/>
    </>
  ),
};

export default function SilverIcon({ name, size = 20, className, style }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      height={size}
      className={className}
      style={style}
    >
      {PATHS[name]}
    </svg>
  );
}
